import axios from 'axios';

import { apiBaseUrl } from '@/apis/appconst';

export async function getBookingList(page_no, limit, booking_page_cre_by) {
    try {
        const response = await axios.post(`${apiBaseUrl}booking_page/list`, { page_no, limit, booking_page_cre_by });
        return response.data;
    } catch (error) {
        return {
            status: false,
            type: "danger",
            message: "Authentication Failed"
        };
    }
}

export async function addBooking(bookingData) {
    try {
        const response = await axios.post(`${apiBaseUrl}booking_page/add`, bookingData);
        return response.data;
    } catch (error) {
        return {
            status: false,
            type: "danger",
            message: "Authentication Failed"
        };
    }
}

export async function uploadImg(file) {
    try {
        const formData = new FormData();
        formData.append('recfile', file); 
        const response = await axios.post(`${apiBaseUrl}booking_page/uploadImg`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        return {
            status: false,
            type: "danger",
            message: error.message
        };
    }
}

export async function getBookingById(booking_page_id) {
    try {
        const response = await axios.post(`${apiBaseUrl}booking_page/get_by_id`, { booking_page_id });
        return response.data;
    } catch (error) {
        return {
            status: false,
            type: "danger",
            message: "Authentication Failed"
        };
    }
}
export async function getBookingByUrl(booking_page_url) {
    try {
        const response = await axios.post(`${apiBaseUrl}booking_page/get_by_url`, { booking_page_url });
        return response.data;
    } catch (error) {
        return {
            status: false,
            type: "danger",
            message: "Authentication Failed"
        };
    }
}

export async function deleteBookingById(booking_page_id) {
    try {
        const response = await axios.post(`${apiBaseUrl}booking_page/delete`, { booking_page_id });
        return response.data;
    } catch (error) {
        return {
            status: false,
            type: "danger",
            message: "Authentication Failed"
        };
    }
}